import { Box, Heading, useColorModeValue, Stack, StackDivider } from '@chakra-ui/react';
import { TooltipProps } from 'recharts';
import { ListingModel } from 'models';
import MarketListingTooltip from './MarketListingTooltip';

interface MarketPriceChartTooltipProps extends TooltipProps<any, any> {
	selectedYear?: number | null;
	selectedMonth?: number | null;
	listings: ListingModel[];
}

export default function MarketPriceChartTooltip(props: MarketPriceChartTooltipProps) {
	const { payload, active, selectedYear, selectedMonth, listings } = props;
	const backgroundColor = useColorModeValue("white", "black");
	const textColor = useColorModeValue("gray.800", "white");
	const borderColor = useColorModeValue("gray.200", "gray.700");

	if (!active || !payload || payload.length === 0) return null;

	const data = payload[0].payload;
	const label = data.date?.format('D MMMM, YYYY') || '';

	if (selectedYear && selectedMonth && data.totalListings === 1) {
		const matchingListings = listings.filter(l => l.date?.format('YYYY-MM-DD') === data.date?.format('YYYY-MM-DD'));
		if (matchingListings.length > 0) {
			return <MarketListingTooltip listings={matchingListings} active={active} label={label} />;
		}
	}

	return (
		<Box borderWidth="1px" borderRadius="lg" p={4} shadow="md" backgroundColor={backgroundColor} borderColor={borderColor}>
			{!!label && <Box mb={4}>
				<Heading size='md' color={textColor}>{label}</Heading>
			</Box>}
			<Stack divider={<StackDivider />} spacing='4' textAlign={'left'}>
				<Box>
					<Box fontSize='xs' textTransform='uppercase' color={textColor}>
						Mean Price
					</Box>
					<Heading pt='2' fontSize='sm' color={textColor}>
						${data.mean}
					</Heading>
				</Box>
				{!!data.percentage && (
					<Box>
						<Box fontSize='xs' textTransform='uppercase' color={textColor}>
							Change
						</Box>
						<Heading pt='2' fontSize='sm' color={data.percentage >= 0 ? 'green.500' : 'red.500'}>
							{data.percentage}%
						</Heading>
					</Box>
				)}
			</Stack>
		</Box>
	);
}
